import { render, staticRenderFns } from "./ApprovalBOM.vue?vue&type=template&id=31bf8e2f&"
import script from "./ApprovalBOM.vue?vue&type=script&lang=js&"
export * from "./ApprovalBOM.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalBOM.vue?vue&type=style&index=0&id=31bf8e2f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports